import React from "react";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import { options } from "util/reactTableFuncs";
import { Team } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const TeamsTable = ({
  teams,
  rowEvents,
  showSearch,
  showAccount,
  showDescription,
  cardTable
}: {
  teams: Team[];
  rowEvents: any;
  showSearch: boolean;
  showAccount?: boolean;
  showDescription?: boolean;
  cardTable?: boolean;
}) => {
  const { SearchBar } = Search;
  const columns: Array<Object> = [
    {
      dataField: "name",
      text: "Team",
      sort: true,
      headerAlign: "left",
        align: "left"
    }
  ];
  if (showAccount) {
    columns.push({
      dataField: "account_name",
      text: "Account",
      sort: true,
      headerAlign: "left",
      align: "left"
    });
  }
  if (showDescription) {
    columns.push({
      dataField: "description",
      text: "Description"
    });
  }
  let dataSorted =
    teams && teams.sort((a: Team, b: Team) => a.name.localeCompare(b.name));
  if (dataSorted && showDescription) {
    // Limit the description to a certain number of characters
    dataSorted = dataSorted.map((team: Team) =>
      team.description && team.description.length > 30
        ? {
            ...team,
            description: `${team.description.substring(0, 30)}...`
          }
        : team
    );
  }
  return (
    <div>
      {teams ? (
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <>
              { showSearch ?
              <div className={styles["table__search-container"]}>
                <SearchBar
                  className={styles["table__search-container__search-bar"]}
                  {...props.searchProps}
                />
              </div>
              : null }
              <div className={Table.classNames.table}>
                {cardTable ? (
                  <BootstrapTable
                    {...props.baseProps}
                    classes="card-table text-center"
                    bordered={false}
                    bootstrap4
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bordered={false}
                    bootstrap4
                    hover
                    condensed
                    rowEvents={rowEvents}
                    pagination={paginationFactory(options)}
                  />
                )}
              </div>
            </>
          )}
        </ToolkitProvider>
      ) : (
        <p>No Teams Available</p>
      )}
    </div>
  );
};

export default TeamsTable;
